import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WdxIconContainerModule } from '@wdx/shared/components/wdx-icon-container';
import { WdxIconButtonComponent } from './wdx-icon-button.component';
import { TranslateTokenisedStringPipe } from '@wdx/shared/utils';

@NgModule({
    imports: [
        CommonModule,
        WdxIconContainerModule,
        TranslateTokenisedStringPipe,
    ],
    declarations: [WdxIconButtonComponent],
    exports: [WdxIconButtonComponent],
})
export class WdxIconButtonModule {}
